/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.atproto.server.updateEmail'

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  email: /*#__PURE__*/ l.string(),
  emailAuthFactor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
  token: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.payload()

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Update an account's email. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output, [
  'ExpiredToken',
  'InvalidToken',
  'TokenRequired',
])

export { main }

export const $lxm = $nsid
